import React from "react";

export default function MyPassword() {
    
    return (
        <>
            <h1 className="dash-title">Change Password</h1>

            <div className="row dash-row">
                
                <div className="col-md-12 col-sm-12 col-12">
                    <div className="card spur-card" style={{marginTop: 5}}>
                        <div className="card-header">
                            <div className="spur-card-title">Change Password</div>
                        </div>
                        <div className="card-body">
                            <form method="post" action="">
                                <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-6 form-group">
                                        <label className="control-label">Current Password: <span>*</span></label>
                                        <input type="password" className="form-control" required name="pass" placeholder="Current Password"/>
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-6 form-group">
                                        <label className="control-label">New Password: <span>*</span></label>
                                        <input type="password" className="form-control" required name="npass" placeholder="Current Password"/>
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-6 form-group">
                                        <label className="control-label">Confirm New Password: <span>*</span></label>
                                        <input type="password" className="form-control" required name="cnpass" placeholder="Current Password"/>
                                    </div>
                                </div>
                                <div className="row form-group">
                                    <div className="col-md-12 col-sm-12">
                                        <button type="submit" className="btn btn-primary" onClick={()=> {console.log('pass')}}>SUBMIT</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
